import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-24 px-4 bg-warm-900 text-warm-50 relative overflow-hidden" data-id="element-166">
      {/* Decorative gold line top */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-167" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-169">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-8 leading-tight" data-id="element-170">
            El verdadero problema: <br data-id="element-171" />
            <span className="text-gold italic font-light" data-id="element-172">
              no es disciplina, es biología
            </span>
          </h2>

          <p className="text-xl md:text-2xl text-warm-100/80 font-light mb-12 max-w-2xl mx-auto" data-id="element-173">
            Intentar razonar con un niño cansado es una batalla perdida.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-warm-800/50 border border-warm-800 rounded-3xl p-8 md:p-12 text-left max-w-3xl mx-auto backdrop-blur-sm" data-id="element-174">
          <p className="text-lg md:text-xl mb-8 text-warm-100" data-id="element-175">
            El Método Cena y Cama utiliza un sistema simple de{' '}
            <strong className="text-gold font-semibold" data-id="element-176">
              anclaje sensorial
            </strong>{' '}
            que:
          </p>

          <ul className="space-y-4 mb-10" data-id="element-177">
            {['Reduce la resistencia de forma natural', 'Elimina negociaciones interminables', 'Prepara el cerebro del niño para dormir'].map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3 + index * 0.1
          }} className="flex items-center gap-4 text-lg text-warm-100/90" data-id="element-178">
                <div className="w-2 h-2 rounded-full bg-gold shrink-0" data-id="element-179" />
                {item}
              </motion.li>)}
          </ul>

          <div className="pt-8 border-t border-warm-800/80 text-center" data-id="element-180">
            <p className="text-xl md:text-2xl font-heading" data-id="element-181">
              Pasamos del caos al silencio total en <br className="md:hidden" data-id="element-182" />
              <span className="text-gold font-bold text-2xl md:text-3xl inline-block mt-2" data-id="element-183">
                15 minutos reales.
              </span>
            </p>
          </div>
        </motion.div>
      </div>

      {/* Decorative gold line bottom */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-184" />
    </section>;
}